import React, { useState } from "react";

const CreateRoleSection = ({ onAddRole }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      onAddRole(inputValue.trim());
      setInputValue("");
    }
  };

  return (
    <div style={styles.inputColumn}>
      <input
        style={styles.input}
        type="text"
        placeholder="Looking for a... ( Press Enter )"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
};

const styles = {
    inputColumn: {
        display: "flex",
        flexDirection: "column",
        width: "100%",          
        gap: "10px",
      },
      input: {
        padding: "12px",        
        fontSize: "14px",       
        borderRadius: "12px",
        border: "1px solid #ddd",
        background: "#f9f9f9",
        fontFamily: "inherit",
        flex: "1",              
        width: "100%",         
        boxSizing: "border-box",
      },
};

export default CreateRoleSection;
